<template>
  <div>
    <n-bread
        v-bind:content="{bread_list, bread_active}"
    ></n-bread>
    <div class="card   abtg__default-card abtg__default-card-border">

      <div class="card-body ">
        <h3>Le caratteristiche del servizio</h3>
        <p>
         Il servizio "Idealista" permette di importare - dal sito idealista.it - gli immobili in vendita direttamente in Real Estate Pro.
          Questo servizio si aggiunge alla ricerca degli annunci immobiliari nel mercato libero, già presente su Real Estate Pro.
        </p>



        <h3>Aggiornamento</h3>
        <p>Il risultato ottenuto è in tempo reale.</p>

        <h3>Costi</h3>
        <p>Il costo del servizio è pari alle <strong>chiamate</strong>: questo significa che il wallet digitale
          a tua disposizione scalerà i crediti per ogni utilizzo del servizio: la quantità di immobili restituiti da idealista non influisce sul costo.<br>
          Il costo di ogni singola chiamata è di <strong>n. {{price}} crediti</strong>.</p>

      </div>
    </div>
  </div>
</template>

<script>
import NBread from '@/partials/bread';
import {mapActions, mapState, mapMutations} from 'vuex';

export default {
  components: {
    NBread
  },
  computed: {
    ...mapState('n_idealista', ['bread_active', 'bread_list', 'price']),
  },

  created() {
    this.SET_DATA({name: 'bread_active', data: {label: 'Servizio Idealista'}});
    this.getPrice();
  },
  methods: {
    ...mapActions('n_idealista', ['getPrice']),
    ...mapMutations('n_idealista', ['SET_DATA']),
  }
}
</script>
